import './MembershipEditorShell.css';

type MembershipEditorShellProps = {
  title: string;
  subtitle: string;
  meta?: React.ReactNode;
  progress?: React.ReactNode;
  progressLabel?: string;
  actions?: React.ReactNode;
  leftColumn: React.ReactNode;
  rightColumn: React.ReactNode;
  breadcrumb?: string;
};

const MembershipEditorShell = ({
  title,
  subtitle,
  meta,
  progress,
  progressLabel,
  actions,
  leftColumn,
  rightColumn,
  breadcrumb
}: MembershipEditorShellProps) => (
  <section className="membership-editor-shell">
    <section className="dashboard-tab-hero membership-editor-shell__hero">
      <div className="dashboard-tab-hero-copy">
        {breadcrumb ? (
          <div className="membership-editor-shell__breadcrumb" aria-label="Breadcrumb">
            <span>Memberships</span>
            <span aria-hidden="true">›</span>
            <span>{breadcrumb}</span>
          </div>
        ) : null}
        <p className="dashboard-tab-hero-eyebrow">Loyalty Operations</p>
        <h3 className="dashboard-tab-hero-title">{title}</h3>
        <p className="dashboard-tab-hero-subtitle">{subtitle}</p>
        {meta ? <div className="membership-editor-shell__meta">{meta}</div> : null}
      </div>
      {actions ? <div className="membership-editor-shell__actions">{actions}</div> : null}
    </section>

    {progress ? (
      <div className="membership-editor-shell__progress">
        {progress}
        {progressLabel ? (
          <span className="membership-editor-shell__progress-label">{progressLabel}</span>
        ) : null}
      </div>
    ) : null}

    <div className="membership-editor-shell__body">
      <div className="membership-editor-shell__main">
        {leftColumn}
      </div>
      <aside className="membership-editor-shell__aside">
        {rightColumn}
      </aside>
    </div>
  </section>
);

export default MembershipEditorShell;
